
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^webpack_sharing_consume_default_(clsx_clsx|date\-fns_date\-fns|react\-router\-dom_react\-router\-dom)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
